import { coreInstance } from "../index.js";
import router from "../../router/index.js";
export default {
  namespaced: true,
  state: {
    reportDetail: { best_seller: [] },
    orderReportList: [],
    chartDataOrderPerDay: {
      labels: ["00.01", "00.02", "0.003"],
      datasets: [
        {
          label: '',
          backgroundColor: "#63e8ac",
          data: [40, 20, 30],
        },
      ],
    },
    chartDataPricePerDay: {
      labels: ["00.01", "00.02", "0.003"],
      datasets: [
        {
          label:'',
          backgroundColor: "#52abff",
          data: [40, 20, 30],
        },
      ],
    },
  },
  mutations: {
    sortOrderTable(state, value) {
      state.orderReportList.sort(function (a, b) {
        if (a.order_total_price === b.order_total_price) {
          return 0;
        } else if (a.order_status === 7) {
          return 1;
        } else if (b.order_status === 7) {
          return -1;
        } else if (value == "pricelowtohigh") {
          return a.order_total_price - b.order_total_price;
        } else if (value == "pricehightolow") {
          return b.order_total_price - a.order_total_price;
        }
      });
    },
    resetOrderTable(state) {
      state.orderReportList = JSON.parse(
        JSON.stringify(state.reportDetail.orders)
      );
    },
    setReportDetail(state, data) {
      state.reportDetail = data;
    },
    setOrderReportList(state, data) {
      state.orderReportList = JSON.parse(JSON.stringify(data));
    },
    setGraphValue(state, data) {
      state.chartDataOrderPerDay.labels = data.collect_graph.map(
        (val) => val.day
      );
      if (state.chartDataOrderPerDay.datasets.length > 0) {
        state.chartDataOrderPerDay.datasets[0].data = data.collect_graph.map(
          (val) => val.count
        );
      }

      state.chartDataPricePerDay.labels = data.collect_graph.map(
        (val) => val.day
      );
      if (state.chartDataPricePerDay.datasets.length > 0) {
        state.chartDataPricePerDay.datasets[0].data = data.collect_graph.map(
          (val) => val.total_price
        );
      }
    },
  },
  actions: {
    async getReportDetail({ rootState, commit }, configPath) {
      const axiosConfig = {
        headers: {
          Authorization: configPath.refeshToken,
        },
      };
      return coreInstance
        .get(
          "/api/v1/" +
          rootState.Auth.refeshProvince +
          "/merChant/restaurant/getReport/store_id/" +
          rootState.Auth.refeshStoreID +
          "/datetime_start/" +
          configPath.datetime_start +
          "/datetime_end/" +
          configPath.datetime_end,
          axiosConfig
        )
        .then((res) => {
          if (res.data.token) {
            return (window.location =
              process.env.VUE_APP_MER_CORE_URL + "/signout");
          }
          if (res.data.msg == true) {
            commit("setReportDetail", res.data.data);
            commit("setOrderReportList", res.data.data.orders);
            commit("setGraphValue", res.data.data);
            return true;
          } else {
            return false;
          }
        });
      // .catch(
      //   err => (window.location = process.env.VUE_APP_MER_CORE_URL+"/signout")
      // );
    },
  },
  getters: {},
};
